import React from 'react';
import { Button } from 'reactstrap';
import { BUTTON_CONFIGS } from '../../config/serviceDeskConfigs';

function ButtonNewTicket({ projectId, etiquetas, onclick }) {

	const config = BUTTON_CONFIGS[projectId]?.newTicket || BUTTON_CONFIGS.default;

	if (config.customRender) {
		return config.customRender({ etiquetas, onclick  });
	}

	const button = (
		<Button
			block={config.block}
			color={config.color}
			className={config.buttonClass}
			onClick={onclick}
			title={etiquetas.title}
		>
			<i className={config.icon} />
			{etiquetas.title}
		</Button>
	);

	return config.wrapperClass ? (
		<div className={config.wrapperClass}>{button}</div>
	) : button;
}

export default ButtonNewTicket;